
module Meevo.Model {

    export interface IDateRange {
        from: string;
        to: string;
    }

    export interface IDateFilter {
        min: Date;
        max: Date;
    }

    export interface IStageDateRange {
        date: IDateFilter;
    }

    export interface IPayrollSettings {
        periodSettings: Meevo.Model.PeriodSettings;
        periodDetails: Meevo.Model.IPeriodDetails[];
    }

    export interface IPeriodDetails {
        tenantId?: number;
        locationId?: number;
        payrollStartDate?: Date;
        payrollEndDate?: Date;
        payrollTypeEnum?: PayrollTypeEnum;
        payrollWeekStartDate?: Date;
        payrollFrequency?: string;
        payrollPeriodStatus?: string;
        hasShutOffPayrollCurrently?: boolean;
    }

    export enum PayrollTypeEnum {
        Service = 20056,
        Retail = 20057,
        SR = 20063
    }

    export interface PayrollMostRecentStartDate {
        payrollTypeEnum?: PayrollTypeEnum;
        startDate?: Date; 
     }


}

module Meevo.Plugins.CompensationSettings {
    "use strict";

    /**
    * Main Section of Compensation Settings 
    */

    export class MainSection extends Meevo.Components.CommonClasses.SettingsSectionBase {


        private payrollFrequencyExclusionList: Meevo.Model.PayrollFrequencyEnum[] = [Meevo.Model.PayrollFrequencyEnum.SemiMonthly];
        protected temps: Meevo.Model.PeriodSettings;
        private servicePayrollProjections: Meevo.Model.IDateRange[] = [];
        private retailPayrollProjections: Meevo.Model.IDateRange[] = [];
        private serviceCurrentPayrollProjections: Meevo.Model.IDateRange[] = [];
        private retailCurrentPayrollProjections: Meevo.Model.IDateRange[] = [];
        private stageServiceDateFilter: Meevo.Model.IStageDateRange;
        private stageRetailDateFilter: Meevo.Model.IStageDateRange;
        private compensationDataService: Meevo.Components.CommonClasses.ICompensationSettingsService;
        private isStagePayrollWorkWeekStartsDisabled: boolean = false
        private showRetailPayrollFrequency: boolean = false;
        private lastRetailPayrollDate: Date;
        private lastServicePayrollDate: Date;
        private retailMinDate: Date;
        private serviceMinDate: Date;
        // private periodDetails: Meevo.Model.IPeriodDetails[];
        private PayrollServicePeriodLabel: string;
        private currentRetailPeriod: Meevo.Model.IPeriodDetails;
        private currentServicePeriod: Meevo.Model.IPeriodDetails;
        private pastPayrollExists: boolean;
        private pastShutOffPayrollExists: boolean;
        private isCustomSemiMonthlySelected: boolean = false;
        private isCustomMonthlySelected: boolean = false;
        private mostRecentStartDateforML: Model.PayrollMostRecentStartDate[] = [];
        private servicePayrollFrequencyExcludeList: Model.PayrollFrequencyEnum[] = [Model.PayrollFrequencyEnum.Quarterly];

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum,
            identityService: Components.Common.IIdentityService,
            modalService: Meevo.Components.Modal.IModalService,
            private trackingService: Meevo.Components.Tracking.ITrackingService,
            private $mdSidenav: ng.material.ISidenavService,
            sectionSecurityKey?: string
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, modalService, sectionSecurityKey)
            this.compensationDataService = this.dataService as Meevo.Components.CommonClasses.ICompensationSettingsService;
            this.onInit();
            if (this.identityService.inCentralOfficeMode()) {
                this.getPayPeriodMostRecentStartDate();
            }
        }

        activate(): void {
            super.activate();
            //if (Model.Guard.isSomething(this.model) && this.identityService.inCentralOfficeMode) {
            //    this.model.payrollTracking = true;
            //}

        }

        onInit = () => {
            this.compensationDataService.getPayrollSettings(true).then((res: Meevo.Model.IPayrollSettings) => {
                this.model = res.periodSettings;
                if (Model.Guard.isSomething(res.periodDetails) && res.periodDetails.length > 0) {
                    for (var i = 0; i < res.periodDetails.length; i++) {
                        this.pastPayrollExists = true;
                        this.pastShutOffPayrollExists = res.periodDetails[i].hasShutOffPayrollCurrently
                        if (res.periodDetails[i].payrollTypeEnum == Model.PayrollTypeEnum.Retail)
                            this.currentRetailPeriod = res.periodDetails[i];
                        else
                            this.currentServicePeriod = res.periodDetails[i];
                    }
                }
                this.setMinDates();
                this.takeBackup();
                this.loadTemps();
                this.calculateCurrentProjections();
                this.calculateStageProjections();
            })
        }

        setMinDates = () => {
            this.retailMinDate = null;
            this.serviceMinDate = null;
            if (Model.Guard.isSomething(this.currentServicePeriod))
                this.serviceMinDate = this.currentServicePeriod.hasShutOffPayrollCurrently ? moment(this.currentServicePeriod.payrollEndDate).add(1, 'days').toDate() : this.currentServicePeriod.payrollStartDate;
            if (Model.Guard.isSomething(this.currentRetailPeriod))
                this.retailMinDate = this.currentRetailPeriod.hasShutOffPayrollCurrently ? moment(this.currentRetailPeriod.payrollEndDate).add(1, 'days').toDate() : this.currentRetailPeriod.payrollStartDate;

        }

        loadTemps = () => {
            this.temps = angular.copy(this.model);

            if (!this.isPayrollPeriodChangeScheduled()) {
                this.temps.stagePayrollRetailCommissionFrequency = (<Meevo.Model.PeriodSettings>this.model).payrollRetailCommissionFrequency;
                this.temps.stagePayrollServiceCommissionFrequency = (<Meevo.Model.PeriodSettings>this.model).payrollServiceCommissionFrequency;
                this.temps.stagePayrollWorkWeekStarts = (<Meevo.Model.PeriodSettings>this.model).payrollWorkWeekStarts;
            }
            if (this.identityService.inCentralOfficeMode()) {
                this.temps.stageEnableMultiLocationPayroll = (<Meevo.Model.PeriodSettings>this.model).enableMultiLocationPayroll || (<Meevo.Model.PeriodSettings>this.model).stageEnableMultiLocationPayroll ;
            }
            this.showRetailPayrollFrequency = this.trackingRetailSeparately();
            this.setServiceDateRange();
            this.stageRetailDateFilter = this.setDateRange(this.retailMinDate, this.temps.stagePayrollRetailCommissionFrequency, Model.PayrollTypeEnum.Retail);
            this.isStagePayrollWorkWeekStartsDisabled = this.isServiceFrequencyWeekly();

        }

        openPayrollFrequencySettings = (isEditing: boolean = false, componentId: string = 'payrollPeriodSettings') => {
            if (this.disabledPayrollsettings()) {
                this.modalService.alert("LABEL_MULTI_LOCACTION_PAYROLL_ENABLED", 0, true);
                return;
            }

            this.mode === Meevo.Model.MaintenanceFormState.Editing;

            let canConfigurePayroll = this.isPayrollPeriodChangeScheduled() || this.temps.stagePayrollStopTracking
            let warning: string;

            if (canConfigurePayroll && !isEditing) {
                if (this.isPayrollPeriodChangeScheduled()) {
                    warning = 'LABEL_PAYROLL_ALREADY_PERIOD_SCHEDULED_PLEASE_MAKE_CHANGES_TO_CURRENT'
                } else if (this.temps.stagePayrollStopTracking) {
                    warning = 'LABEL_PAYROLL_TRACKING_IS_ENABLE_PLEASE_STOP_TRACKING'
                }
                this.modalService.alert(warning, Components.Modal.ModalTranslationModes.Translate)
            } else {
                if (!isEditing) {
                    this.temps.stagePayrollServiceCommissionEndDate = null;
                    this.temps.stagePayrollRetailCommissionEndDate = null;
                    this.temps.stagePayrollServiceCommissionFrequency = null;
                    this.calculateStageProjections();
                    let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollSettingsMain, Model.VerbEnum.ConfigurePayrollClicked, null, this.parentItemId);
                    this.trackingService.saveTrackingInfo(trackingItem)
                }
                let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollSettingsMain, Model.VerbEnum.EditButtonClicked, null, this.parentItemId)
                this.trackingService.saveTrackingInfo(trackingItem)
                return this.$mdSidenav(componentId).open();
            }
        }

        closePayrollFrequencySettings = (componentId: string = 'payrollPeriodSettings') => {
            return this.$mdSidenav(componentId).close();
        }

        enumValueOf = (value: number) => {
            return Meevo.Model.PayrollFrequencyEnum[value] || Meevo.Model.WeekdayNameEnum[value]
        }

        isPayrollPeriodChangeScheduled = () => {
            return Model.Guard.isSomething(this.model) && ((this.model.stagePayrollServiceCommissionEndDate && this.model.stagePayrollRetailCommissionEndDate));
        }

        resetPayrollTracking = () => {
            if (this.disabledPayrollsettings()) {
                this.modalService.alert("LABEL_MULTI_LOCACTION_PAYROLL_ENABLED", 0, true);
                return;
            }

            let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollSettingsMain, Model.VerbEnum.StopPayrollTrackingClicked, { stagePayrollStopTracking: this.model.stagePayrollStopTracking }, this.parentItemId)
            this.trackingService.saveTrackingInfo(trackingItem)

            if (this.model.stagePayrollStopTracking == false) {
                this.modalService.confirm('LABEL_PAYROLL_STOP_TRACKING_ALL_PENDING_FREQUENCIES_WILL_BE_DISCARDED').then((answer) => {
                    if (answer) {
                        this.model.stagePayrollStopTracking = true;
                        this.removeStageData(["StagePayrollStopTracking"]);
                        this.save();

                    }
                });
            }
            if (this.model.stagePayrollStopTracking == true) {
                this.modalService.confirm('LABEL_PAYROLL_UNDO_AND_STOP_SCHEDULED_TAKE_EFFECT_TONIGHT').then((answer) => {
                    if (answer) {
                        this.model.stagePayrollStopTracking = false;
                        this.removeStageData(["StagePayrollStopTracking"]);
                        this.save();
                    }
                });
            }
        }
        resetMultiPayrollTracking() {


            let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollSettingsMain, Model.VerbEnum.StopPayrollTrackingClicked, { stageMultiPayrollStopTracking: this.model.stageMultiPayrollStopTracking }, this.parentItemId)
            this.trackingService.saveTrackingInfo(trackingItem)
            
            if (this.model.stageMultiPayrollStopTracking == false) {
                this.modalService.confirm('LABEL_MULTI_LOCATION_PAYROLL_STOP_TRACKING_ALL_PENDING_FREQUENCIES_WILL_BE_DISCARDED').then((answer) => {
                    if (answer) {
                        this.model.stageMultiPayrollStopTracking = true;
                        this.removeStageData(["StageMultiPayrollStopTracking"]);
                        this.save();

                   }
                });
            }
            if (this.model.stageMultiPayrollStopTracking == true) {
                this.modalService.confirm('LABEL_MULTILOCATION_PAYROLL_UNDO_AND_STOP_SCHEDULED_TAKE_EFFECT_TONIGHT').then((answer) => {
                    if (answer) {
                        this.model.stageMultiPayrollStopTracking = false;
                        this.removeStageData(["StageMultiPayrollStopTracking"]);
                        this.save();
                    }
                });
            }
        }

        removeStageData = (excludeSettings?: string[]) => {
            _.forEach(this.model.settings, (s: any) => {
                if (s.displayName.toLowerCase().indexOf("stage") >= 0) {
                    if (Model.Guard.isNothing(excludeSettings) || excludeSettings.length <= 0 || excludeSettings.indexOf(s.displayName) < 0)
                        this.revertToParent(s.displayName, null);
                }
            });

            this.processRevertedSettings(this.model, this.originalEntity,false);
        }

        resetPayrollFrequencySettings = () => {

            if (this.disabledPayrollsettings()) {
                this.modalService.alert("LABEL_MULTI_LOCACTION_PAYROLL_ENABLED", 0, true);
                return;
            }
            this.modalService.confirm('LABEL_PAYROLL_DELETE_WILL_BE_PERMANENT').then((answer) => {
                if (answer) {
                    this.removeStageData();
                    let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollSettingsMain, Model.VerbEnum.DeleteButtonClicked, null, this.parentItemId)
                    this.trackingService.saveTrackingInfo(trackingItem)
                    this.save();
                }
            })
        }

        serviceEndDateChanged = () => {

            if (Model.Guard.isNothing(this.temps.stagePayrollServiceCommissionEndDate))
                return;
            if (this.identityService.inCentralOfficeMode()) {
                this.temps.multiLocationPayrollServiceCommissionStartDate = moment(this.temps.stagePayrollServiceCommissionEndDate).add("days", 1).toDate().toDateString();
            }
            this.isStagePayrollWorkWeekStartsDisabled = this.isServiceFrequencyWeekly();

            if (Model.Guard.isSomething(this.temps.stagePayrollServiceCommissionEndDate) && this.isStagePayrollWorkWeekStartsDisabled) {
                let today = moment(this.temps.stagePayrollServiceCommissionEndDate);
                let tomorrow = Meevo.Model.WeekdayNameEnum[today.add(1, 'Days').lang("en").format('dddd')]
                this.temps.stagePayrollWorkWeekStarts = tomorrow;
            }
            this.updateRetailFromService();
            this.calculateStageProjections();
        }

        retailEndDateChanged = () => {
            this.calculateStageProjections();
        }

        isServiceFrequencyWeekly = (): boolean => {
            return Model.Guard.isNothing(this.temps.stagePayrollServiceCommissionFrequency)
                || this.temps.stagePayrollServiceCommissionFrequency === Meevo.Model.PayrollFrequencyEnum.Weekly
                || this.temps.stagePayrollServiceCommissionFrequency === Meevo.Model.PayrollFrequencyEnum.BiWeekly
                || this.temps.stagePayrollServiceCommissionFrequency === Meevo.Model.PayrollFrequencyEnum.FourWeek
        }

        validateServiceDate = () => {
            this.isStagePayrollWorkWeekStartsDisabled = this.isServiceFrequencyWeekly();
            this.temps.stagePayrollServiceCommissionEndDate = null;

            this.setServiceDateRange();

            this.updateRetailFromService();

            this.isCustomSemiMonthlySelected = !Model.Guard.isNothing(this.temps.stagePayrollServiceCommissionFrequency)
                && this.temps.stagePayrollServiceCommissionFrequency === Meevo.Model.PayrollFrequencyEnum.CustomSemiMonthly;
            this.isCustomMonthlySelected = !Model.Guard.isNothing(this.temps.stagePayrollServiceCommissionFrequency)
                && this.temps.stagePayrollServiceCommissionFrequency === Meevo.Model.PayrollFrequencyEnum.CustomMonthly;
        }

        setServiceDateRange = () => {
            if (!this.showRetailPayrollFrequency && this.retailMinDate > this.serviceMinDate)
                this.stageServiceDateFilter = this.setDateRange(this.retailMinDate, this.temps.stagePayrollServiceCommissionFrequency, Model.PayrollTypeEnum.Retail);
            else
                this.stageServiceDateFilter = this.setDateRange(this.serviceMinDate, this.temps.stagePayrollServiceCommissionFrequency, Model.PayrollTypeEnum.Service);
        }

        validateRetailDate = () => {
            this.temps.stagePayrollRetailCommissionEndDate = null;
            this.stageRetailDateFilter = this.setDateRange(this.retailMinDate, this.temps.stagePayrollRetailCommissionFrequency, Model.PayrollTypeEnum.Retail);
        }


        setDateRange = (minDate: Date, selectedPayrollFrequency: Meevo.Model.PayrollFrequencyEnum, payrollTypeEnum: Model.PayrollTypeEnum): Model.IStageDateRange => {
            var min: any;
            var max: any;
            let lclMinDate = Model.Guard.isSomething(minDate) ? moment(minDate) : null;
            let frequency: number = this.getPayrollFrequency(selectedPayrollFrequency);
            var mostRecentDates = this.mostRecentStartDateforML;
            if (this.identityService.inCentralOfficeMode()) {

                let minDate = _.findWhere(mostRecentDates, (item: Model.PayrollMostRecentStartDate) => {
                    return item.payrollTypeEnum == payrollTypeEnum;
                })
                if (Model.Guard.isSomething(minDate))
                lclMinDate = moment(minDate.startDate);
            }
            min = moment().subtract(frequency, "Days");
            max = moment();
            if (Model.Guard.isSomething(lclMinDate) && lclMinDate > min)
                min = lclMinDate;

            if (selectedPayrollFrequency == Meevo.Model.PayrollFrequencyEnum.Quarterly) {
                max = max.add(frequency, "Days");
            }
            else
                max = max.add(1, 'Months').endOf('Month');

            return {
                date: {
                    min: min.toDate(),
                    max: max.toDate()
                }
            }

        }

        getPayrollFrequency = (payrollFrequency: Meevo.Model.PayrollFrequencyEnum) => {
            switch (payrollFrequency) {
                case Meevo.Model.PayrollFrequencyEnum.Monthly:
                case Meevo.Model.PayrollFrequencyEnum.CustomMonthly:
                    return 31;
                case Meevo.Model.PayrollFrequencyEnum.CustomSemiMonthly:
                case Meevo.Model.PayrollFrequencyEnum.SemiMonthly:
                    return 16;
                case Meevo.Model.PayrollFrequencyEnum.BiWeekly:
                    return 13;
                case Meevo.Model.PayrollFrequencyEnum.Weekly:
                    return 6;
                case Meevo.Model.PayrollFrequencyEnum.FourWeek:
                    return 27;
                case Meevo.Model.PayrollFrequencyEnum.Quarterly:
                    return 92;
                default:
                    return 0;
            }
        }

        setServiceEndDateFilter = (date: Date) => {
            let selectedPayrollFrequency: Meevo.Model.PayrollFrequencyEnum = this.temps.stagePayrollServiceCommissionFrequency;
            switch (selectedPayrollFrequency) {
                case Meevo.Model.PayrollFrequencyEnum.Monthly:
                    return this.isMonthly(date);
                case Meevo.Model.PayrollFrequencyEnum.SemiMonthly:
                    return this.isSemiMonthly(date);
                case Meevo.Model.PayrollFrequencyEnum.FourWeek:
                    return this.isFourWeek(date);
                case Meevo.Model.PayrollFrequencyEnum.CustomSemiMonthly:
                    return this.enableCustomSemiMonthlyDate(date);
                case Meevo.Model.PayrollFrequencyEnum.CustomMonthly:
                    return this.enableCustomMonthlyDate(date);
               default:
                    return true;
            }
        }

        setRetailEndDateFilter = (date: Date) => {
            let selectedPayrollFrequency: Meevo.Model.PayrollFrequencyEnum = this.temps.stagePayrollRetailCommissionFrequency;
            switch (selectedPayrollFrequency) {
                case Meevo.Model.PayrollFrequencyEnum.Monthly:
                    return this.isMonthly(date);
                case Meevo.Model.PayrollFrequencyEnum.SemiMonthly:
                    return this.isSemiMonthly(date);
                case Meevo.Model.PayrollFrequencyEnum.FourWeek:
                    return this.isFourWeek(date);
                case Meevo.Model.PayrollFrequencyEnum.CustomSemiMonthly:
                    return this.enableCustomSemiMonthlyDate(date);
                case Meevo.Model.PayrollFrequencyEnum.CustomMonthly:
                    return this.enableCustomMonthlyDate(date);
                case Meevo.Model.PayrollFrequencyEnum.Quarterly:
                    return this.isQuarterly(date);
                default:
                    return true;
            }
        }

        isMonthly = (date: Date) => {
            let dayOfMonth = moment(date).date();
            let lastDayOfMonth = moment(date).endOf('Month').date();
            return dayOfMonth === lastDayOfMonth;
        }

        isSemiMonthly = (date: Date) => {
            let dayOfMonth = moment(date).date();
            let middleOfMonth = 15;
            let lastDayOfMonth = moment(date).endOf('Month').date();
            return dayOfMonth === middleOfMonth || dayOfMonth === lastDayOfMonth;
        }

        isWeekend = (date: Date) => {
            let day = date.getDay();
            return day === 0 || day === 6;
        }

        isEndOfWeek = (date: Date) => {
            let dayOfWeek = moment(date).day();
            let endOfWeek = moment(date).endOf('Week').startOf('Day').day();
            return dayOfWeek === endOfWeek
        }

        isFourWeek = (date: Date) => {
            const dayOfMonth = moment(date);
            const fourWeek = 27;
            const firstDayOfFourWeek = moment(date).subtract(fourWeek, 'days');
            return dayOfMonth >= firstDayOfFourWeek
        }

        isQuarterly = (date: Date) => {
            const m = date.getMonth() + 1;
            const d = date.getDate();

            return ((m == 3 && d == 31) || (m == 6 && d == 30) || (m == 9 && d == 30) || (m == 12 && d == 31));
        }

        enableCustomSemiMonthlyDate = (date: Date) => {
            let NoGoDates: number[] = [ 13, 14, 15, 28, 29, 30, 31];

            let dayOfMonth = date.getDate();
            if (NoGoDates.find(d => d == dayOfMonth))
                return false;

            return true;
        }
        enableCustomMonthlyDate = (date: Date) => {
            let NoGoDates: number[] = [28, 29, 30, 31];

            let dayOfMonth = date.getDate();
            if (NoGoDates.find(d => d == dayOfMonth))
                return false;

            return true;
        }
        trackingRetailSeparately = (): boolean => {
            let endDate = (moment(this.temps.stagePayrollRetailCommissionEndDate).toDate().toDateString() !== moment(this.temps.stagePayrollServiceCommissionEndDate).toDate().toDateString())
            let Freqs = (this.temps.stagePayrollRetailCommissionFrequency !== this.temps.stagePayrollServiceCommissionFrequency)
                        
            this.temps.multiLocationPayrollRetailCommissionStartDate = moment(this.temps.stagePayrollRetailCommissionEndDate).add("days", 1).toDate().toDateString();

            return (moment(this.temps.stagePayrollRetailCommissionEndDate).toDate().toDateString() !== moment(this.temps.stagePayrollServiceCommissionEndDate).toDate().toDateString())
                || (this.temps.stagePayrollRetailCommissionFrequency !== this.temps.stagePayrollServiceCommissionFrequency)
        }

        updateRetailFromService = () => {
            if (!this.showRetailPayrollFrequency || (!this.trackingRetailSeparately() && !this.showRetailPayrollFrequency)) {
                this.temps.stagePayrollRetailCommissionFrequency = this.temps.stagePayrollServiceCommissionFrequency;
                this.validateRetailDate();
                this.temps.stagePayrollRetailCommissionEndDate = this.temps.stagePayrollServiceCommissionEndDate;
                if (this.identityService.inCentralOfficeMode()) {
                    this.temps.multiLocationPayrollServiceCommissionStartDate = moment(this.temps.stagePayrollServiceCommissionEndDate).add("days", 1).toDate().toDateString();
                    this.temps.multiLocationPayrollRetailCommissionStartDate = moment(this.temps.stagePayrollRetailCommissionEndDate).add("days", 1).toDate().toDateString();
                }
            }
        }

        save = () => {
            this.compensationDataService.saveSettings(Model.BusinessSettingCategoryEnum.Period, this.model).then((res) => {
                this.closePayrollFrequencySettings();
                this.onInit();
            })

        }

        cancelEditScreen = () => {
            this.loadTemps();
            this.closePayrollFrequencySettings();
        }

        saveSettingsConfirmation = (isInValid: any) => {
            if (isInValid) {
                this.modalService.alert("MESSAGE_COMPLETE_ALL_FIELDS_THAT_REQUIRE_ATTENTION", 0, true);
                return;
            }

            this.updateRetailFromService();
            this.calculateStageProjections();
            this.temps.stagePayrollTracking = true;
            let modal: Meevo.Components.Modal.IModalOptions = {
                clickOutsideToClose: false,
                templateUrl: "app/plugins/compensationSettings/modals/configurePayrollSettings.html",
                controller: "meevo.configurePayrollSettings.configurePayrollSettingsController",
                controllerAs: "ctrl",
                escapeToClose: true,
                bindToController: true,
                locals: {
                    settings: this.temps, serviceProjections: this.servicePayrollProjections, retailProjections: this.retailPayrollProjections
                }
            }
            if (this.identityService.inCentralOfficeMode()) {

                this.modalService.confirmHandler("MESSAGE_MLP_SETTINGS_CO_UPDATE", Meevo.Components.Modal.ModalTranslationModes.Translate)
                    .then((response: boolean) => {
                        if (response) {
                            this.modalService.showCustom(modal).then((confirm) => {
                                if (confirm) {
                                    let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollSettingsMain, Model.VerbEnum.ConfirmPayrollSettingsSaveClicked, this.temps, this.parentItemId)
                                    this.trackingService.saveTrackingInfo(trackingItem)
                                    this.model = angular.copy(this.temps);
                                    this.save()
                                }
                            })

                        }
                    });
            }
            else {
                this.modalService.showCustom(modal).then((confirm) => {
                    if (confirm) {
                        let trackingItem = new Model.TrackingItem(Model.NounEnum.PayrollSettingsMain, Model.VerbEnum.ConfirmPayrollSettingsSaveClicked, this.temps, this.parentItemId)
                        this.trackingService.saveTrackingInfo(trackingItem)
                        this.model = angular.copy(this.temps);
                        this.save()
                    }
                })
            }
        }

        toggleTrackingTogether = () => {
            this.setServiceDateRange();
            this.calculateStageProjections();
        }

        calculateCurrentProjections = () => {

            this.serviceCurrentPayrollProjections = [];
            this.retailCurrentPayrollProjections = [];

            if (this.model.payrollTracking || this.model.enableMultiLocationPayroll) {

                let sPeriod: Model.IDateRange = { from: null, to: null };
                let rPeriod: Model.IDateRange = { from: null, to: null };

                if (Model.Guard.isSomething(this.currentServicePeriod))
                    this.serviceCurrentPayrollProjections = this.serviceCurrentPayrollProjections.concat(this.getFuturePeriods(this.model.payrollServiceCommissionFrequency, moment(this.currentServicePeriod.payrollEndDate).add(1, 'days')));
                if (Model.Guard.isSomething(this.currentRetailPeriod))
                    this.retailCurrentPayrollProjections = this.retailCurrentPayrollProjections.concat(this.getFuturePeriods(this.model.payrollRetailCommissionFrequency, moment(this.currentRetailPeriod.payrollEndDate).add(1, 'days')));
            }
        }

        calculateStageProjections = () => {
            this.servicePayrollProjections = [];
            this.retailPayrollProjections = [];
            this.updateRetailFromService();

            if (Model.Guard.isNothing(this.temps.stagePayrollServiceCommissionEndDate))
                return


            let selectedServiceFreq = this.temps.stagePayrollServiceCommissionFrequency;
            let selectedServiceEndDate = moment(this.temps.stagePayrollServiceCommissionEndDate);

            let selectedRetailFreq = this.temps.stagePayrollRetailCommissionFrequency;
            let selectedRetailEndDate = moment(this.temps.stagePayrollRetailCommissionEndDate);



            let lastRetailPayrollEndDate = this.pastPayrollExists && Model.Guard.isSomething(this.currentRetailPeriod) ? this.currentRetailPeriod.payrollEndDate : moment('1/1/1900');

            let lastServicePayrollEndDate = this.pastPayrollExists && Model.Guard.isSomething(this.currentServicePeriod) ? this.currentServicePeriod.payrollEndDate : moment('1/1/1900');

            let lastRetailPayrollStartDate = this.pastPayrollExists && Model.Guard.isSomething(this.currentRetailPeriod) ? this.currentRetailPeriod.payrollStartDate : moment('1/1/1900');

            let lastServicePayrollStartDate = this.pastPayrollExists && Model.Guard.isSomething(this.currentServicePeriod) ? this.currentServicePeriod.payrollStartDate : moment('1/1/1900');


            let firstServiceStart = this.getFirstDayofPayroll(selectedServiceFreq, selectedServiceEndDate);

            let firstRetailStart = this.getFirstDayofPayroll(selectedRetailFreq, selectedRetailEndDate);

            if (Model.Guard.isSomething(this.currentServicePeriod))
                firstServiceStart = this.pastShutOffPayrollExists ? moment.max([moment(lastServicePayrollEndDate).add(1, 'days'), firstServiceStart]) : moment(lastServicePayrollStartDate);
            if (Model.Guard.isSomething(this.currentRetailPeriod))
                firstRetailStart = this.pastShutOffPayrollExists ? moment.max([moment(lastRetailPayrollEndDate).add(1, 'days'), firstRetailStart]) : moment(lastRetailPayrollStartDate);

            let sPeriod: Model.IDateRange = { from: null, to: null };;
            let rPeriod: Model.IDateRange = { from: null, to: null };;

            sPeriod.from = firstServiceStart.format();
            sPeriod.to = selectedServiceEndDate.format();
            this.servicePayrollProjections.push(sPeriod);
            this.servicePayrollProjections = this.servicePayrollProjections.concat(this.getFuturePeriods(selectedServiceFreq, selectedServiceEndDate.add(1, 'days')));
            this.temps.stagePayrollServiceCommissionStartDate = this.servicePayrollProjections[0].from;

            if (!!selectedRetailEndDate.isValid()) {
                rPeriod.from = firstRetailStart.format();
                rPeriod.to = selectedRetailEndDate.format();
                this.retailPayrollProjections.push(rPeriod);
                this.retailPayrollProjections = this.retailPayrollProjections.concat(this.getFuturePeriods(selectedRetailFreq, selectedRetailEndDate.add(1, 'days')));
                this.temps.stagePayrollRetailCommissionStartDate = this.retailPayrollProjections[0].from;
            }
        }

        getFirstDayofPayroll(frequency: any, endDate: any): moment.Moment {

            let mEndDate = moment(endDate);
            switch (frequency) {
                case Meevo.Model.PayrollFrequencyEnum.Monthly:
                    return mEndDate.startOf('Month');
                case Meevo.Model.PayrollFrequencyEnum.SemiMonthly:
                    return mEndDate.toDate().getDate() >= 16 ? mEndDate.startOf('Month').add(15, 'days') : mEndDate.startOf('Month');
                case Meevo.Model.PayrollFrequencyEnum.Weekly:
                    return mEndDate.subtract(6, 'days');
                case Meevo.Model.PayrollFrequencyEnum.BiWeekly:
                    return mEndDate.subtract(13, 'days');
                case Meevo.Model.PayrollFrequencyEnum.FourWeek:
                    return mEndDate.subtract(27, 'days');
                case Meevo.Model.PayrollFrequencyEnum.CustomSemiMonthly:
                    let startDates: number[] = [0, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 0, 0, 0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 0, 0, 0, 0];
                    let dayOfMonth = mEndDate.toDate().getDate();
                    mEndDate.set('date', startDates[dayOfMonth]);
                    if (dayOfMonth <= 16) mEndDate.subtract(1, 'Month');
                    return mEndDate;
                case Meevo.Model.PayrollFrequencyEnum.CustomMonthly:
                    return mEndDate.subtract(1, 'Month');
                case Meevo.Model.PayrollFrequencyEnum.Quarterly:
                    mEndDate.startOf('Month');
                    return mEndDate.subtract(2, 'Month');
            }
        }


        getFuturePeriods(frequency: any, startDate: any): Model.IDateRange[] {

            let futurePeriods: Model.IDateRange[] = [];
            let mDate = moment(startDate);

            for (var loop = 0; loop < 3; loop++) {

                let period: Model.IDateRange = { from: mDate.format(), to: null };
                switch (frequency) {
                    case Meevo.Model.PayrollFrequencyEnum.Monthly:
                        mDate = mDate.endOf('Month');
                        break;
                    case Meevo.Model.PayrollFrequencyEnum.SemiMonthly:
                        mDate = mDate.toDate().getDate() >= 16 ? mDate.endOf('Month') : mDate.startOf('Month').add(14, 'days');
                        break;
                    case Meevo.Model.PayrollFrequencyEnum.Weekly:
                        mDate = mDate.add(6, 'days');
                        break;
                    case Meevo.Model.PayrollFrequencyEnum.BiWeekly:
                        mDate = mDate.add(13, 'days');
                        break;
                    case Meevo.Model.PayrollFrequencyEnum.FourWeek:
                        mDate = mDate.add(27, 'days');
                        break;
                    case Meevo.Model.PayrollFrequencyEnum.CustomSemiMonthly:
                        let endDates: number[] = [0, 0, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 0, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
                        let payPeriodStartDate = mDate.toDate().getDate();
                        mDate.set('date', endDates[payPeriodStartDate]);
                        if (payPeriodStartDate >= 16)
                            mDate.add(1, 'month');
                        break;
                    case Meevo.Model.PayrollFrequencyEnum.CustomMonthly:
                        mDate.add(1, 'Month');
                        mDate.subtract(1, 'days');
                        break;
                    case Meevo.Model.PayrollFrequencyEnum.Quarterly:
                        mDate.add(3, 'Month');
                        mDate.subtract(1, 'days');
                        break;
                }

                period.to = mDate.format();
                futurePeriods.push(period);
                mDate = mDate.add(1, 'days');
            }

            return futurePeriods;
        }

        showPayrollSettings(): boolean {

            if (!this.identityService.inCentralOfficeMode()) {
                return true;
            }

            if (Model.Guard.isSomething(this.model))
                return this.temps.stageEnableMultiLocationPayroll;
        }

        disabledPayrollsettings(): boolean {
           
            if (this.identityService.inCentralOfficeMode() || this.identityService.isSingleLocation() || Model.Guard.isNothing(this.model)) {
                return false;
            }

            if (Model.Guard.isSomething(this.model))
                return this.model.enableMultiLocationPayroll || this.model.stageEnableMultiLocationPayroll;
         }

        isPayrollTrackingEnable(): boolean {
            
            if (this.identityService.inCentralOfficeMode() || this.model.enableMultiLocationPayroll || this.model.stageEnableMultiLocationPayroll) {
                return true;
            }
            if (Model.Guard.isNothing(this.model)) {
                return false;
            }
            if (Model.Guard.isSomething(this.model))
                return this.model.payrollTracking;
        }

        getPayPeriodMostRecentStartDate(): any {

            return this.compensationDataService.getPayPeriodMostRecentStartDate().then((res: any) => {
                this.mostRecentStartDateforML = res;
                return res;
            });
        }
        canEditMLPayroll(): boolean {
            if (this.identityService.inCentralOfficeMode()) {
                return true;
            }
            else {
                return false;
            }
        }

    }

}